import styled, { css } from "styled-components";

import { colors, space, transition, zIndex } from "shared/styles/constants";

const progressCSS = (isActive?: boolean) => css`
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  left: 16px;

  width: ${space.xxs};

  background-color: ${isActive ? colors.green : colors.grey3};
  z-index: ${zIndex.default};
`;

export interface StyledPermissionGroupProps {
  isLast?: boolean;
  isActive?: boolean;
}

export const StyledPermissionGroup = styled.div<StyledPermissionGroupProps>`
  position: relative;
  padding-bottom: ${({ isLast }) => (isLast ? 0 : space.xl)};

  &::before {
    ${progressCSS()}
  }

  &::after {
    ${({ isActive }) => progressCSS(isActive)};
  }

  ${({ isLast }) =>
    isLast &&
    css`
      &::before,
      &::after {
        content: none;
      }
    `}
`;

export interface StyledPermissionFieldProps {
  isGroup?: boolean;
  isLast?: boolean;
  isActive?: boolean;
}

export const StyledPermissionField = styled.div<StyledPermissionFieldProps>`
  position: relative;
  padding-bottom: ${({ isLast }) => (isLast ? 0 : space.xl)};

  > * {
    position: relative;

    z-index: ${zIndex.above};
  }

  &::before {
    ${progressCSS()}
  }

  &::after {
    ${({ isActive }) => progressCSS(isActive)};
  }

  ${({ isGroup, isLast }) =>
    (isGroup || isLast) &&
    css`
      &::before,
      &::after {
        content: none;
      }
    `}
`;

interface StyledPermissionIconProps {
  checked?: boolean;
}

export const StyledPermissionIcon = styled.span<StyledPermissionIconProps>`
  position: relative;

  display: inline-flex;

  padding: ${space.s};
  border-radius: 100%;

  background-color: ${({ checked }) => (checked ? colors.green : colors.grey3)};
  color: ${({ checked }) => (checked ? colors.white : colors.grey5)};

  transition: background-color ${transition.default}, color ${transition.default};

  > svg {
    transition: transform ${transition.default};
  }
`;

export const StyledPermissionLockIcon = styled.span`
  position: absolute;
  top: -${space.xxs};
  right: -${space.xxs};

  display: inline-flex;

  padding: ${space.xxs};
  border-radius: 100%;

  border: 1px solid ${colors.grey4};
  background-color: ${colors.white};
  color: ${colors.grey4};
`;

export const StyledPermissionText = styled.span`
  flex: 1 1 auto !important;

  display: flex;
  flex-direction: column;
  justify-content: center;

  min-height: 36px;

  > * + * {
    margin-top: ${space.xxs};
  }

  transition: opacity ${transition.default};
`;

interface StyledPermissionLabelProps {
  isDisabled?: boolean;
}

export const StyledPermissionLabel = styled.label<StyledPermissionLabelProps>`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;

  > * {
    flex: 0 0 auto;
  }

  > * + * {
    margin-left: ${space.s};
  }

  &:hover ${StyledPermissionIcon} {
    > svg {
      transform: scale(1.3);
    }
  }

  ${({ isDisabled }) =>
    isDisabled &&
    css`
      &:hover ${StyledPermissionText} {
        opacity: 0.5;
      }
    `}
`;

export interface StyledPermissionFieldGroupProps {
  isSubGroup?: boolean;
}
export const StyledPermissionFieldGroup = styled.div<StyledPermissionFieldGroupProps>`
  margin-left: ${({ isSubGroup }) => (isSubGroup ? space.xl : 0)};
`;

export const StyledStickySave = styled.div`
  bottom: 0;
  width: 100%;
  z-index: 100;
  background-color: ${colors.black};
  padding: ${space.l} 0;
  margin: 0 !important;
  margin-bottom: -20px !important;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;
